
import Layout from "../Layout";
import Slider from "../Slider";
import Courses from "./Courses";
import Intro from "./Intro";
import School from "./School";
import Helmet from 'react-helmet';

const Home = () => {
    

    return ( 
        <Layout>
            <Helmet> 
                <meta
                    name="description"
                    content="Life Long Polytechnic is Registered with the Ministry of Higher And Tertiary Education, Science and Technology Development."
                />
                <title>Life Long Polytechnic | Home</title>
            </Helmet>
            <Slider />
            <Intro />
            <School />
            <Courses />
        </Layout>
     );
}
 
export default Home;